import { Controller } from "@hotwired/stimulus"

// Gère une liste dynamique d'options (ou d'items) pour les questions de type
// choice/poll/ranking. Supporte l'ajout et le retrait avec génération automatique
// des IDs (a, b, c…), renumérotation des index après suppression, et bornes min/max.
//
// paramName : clé utilisée dans le nom des inputs (ex: "options" ou "items"),
//             par défaut "options".
export default class extends Controller {
  static targets = ["list", "template", "addButton"]
  static values = {
    min: { type: Number, default: 2 },
    max: { type: Number, default: 8 },
    paramName: { type: String, default: "options" }
  }

  connect() {
    this.updateButtons()
  }

  add(event) {
    event.preventDefault()
    if (this.currentCount >= this.maxValue) return

    const newIndex = this.currentCount
    const newId = this.nextAvailableId()
    const newIdUpper = newId.toUpperCase()

    const templateHtml = this.templateTarget.innerHTML
      .replaceAll("__INDEX__", newIndex)
      .replaceAll("__ID_UPPER__", newIdUpper)
      .replaceAll("__ID__", newId)

    this.listTarget.insertAdjacentHTML("beforeend", templateHtml)
    this.renumber()
    this.updateButtons()
  }

  remove(event) {
    event.preventDefault()
    if (this.currentCount <= this.minValue) return

    const item = event.currentTarget.closest("[data-option-item]")
    if (!item) return

    item.remove()
    this.renumber()
    this.ensureCorrectRadioSelected()
    this.updateButtons()
  }

  // === Helpers ===

  get currentCount() {
    return this.listTarget.querySelectorAll("[data-option-item]").length
  }

  nextAvailableId() {
    const used = new Set()
    this.listTarget.querySelectorAll("[data-option-item]").forEach((item) => {
      if (item.dataset.optionId) used.add(item.dataset.optionId)
    })
    const letters = "abcdefghijklmnopqrstuvwxyz".split("")
    return letters.find((letter) => !used.has(letter)) || "z"
  }

  renumber() {
    const pattern = new RegExp(`\\[${this.paramNameValue}\\]\\[\\d+\\]`)
    this.listTarget.querySelectorAll("[data-option-item]").forEach((item, index) => {
      item.querySelectorAll("[name]").forEach((input) => {
        input.name = input.name.replace(pattern, `[${this.paramNameValue}][${index}]`)
      })
      const positionEl = item.querySelector("[data-position-display]")
      if (positionEl) positionEl.textContent = index + 1
    })
  }

  // Pour les questions single_choice : si le radio correct a été supprimé,
  // sélectionne le premier radio restant afin de garantir qu'un correct_id est toujours défini.
  ensureCorrectRadioSelected() {
    const radios = this.listTarget.querySelectorAll("input[type='radio'][name$='[correct_id]']")
    if (radios.length === 0) return
    const anyChecked = Array.from(radios).some((r) => r.checked)
    if (!anyChecked) radios[0].checked = true
  }

  updateButtons() {
    const count = this.currentCount
    this.listTarget.querySelectorAll("[data-option-item] [data-quiz--option-list-action='remove']").forEach((btn) => {
      btn.hidden = count <= this.minValue
    })
    if (this.hasAddButtonTarget) {
      this.addButtonTarget.disabled = count >= this.maxValue
    }
  }
}
